import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CreateTipoPunitorioRequest } from '@models/tipo-punitorio/createTipoPunitorioRequest.model';
import { TipoPunitorioDto } from '@models/tipo-punitorio/tipoPunitorioDto.model';
import { UpdateTipoPunitorioRequest } from '@models/tipo-punitorio/updateTipoPunitorioRequest.model';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class TiposPunitorioService {

  private id!: number;

  set setId(id:number) {
    this.id = id;
  }

  get getId() {
    return this.id;
  }

  constructor(
    private http: HttpClient
  ) { }

  create(createTipoPunitorioRequest:CreateTipoPunitorioRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/TipoPunitorio/Create",createTipoPunitorioRequest);
  }

  update(updateTipoPunitorioRequest:UpdateTipoPunitorioRequest):Observable<any>
  {
    return  this.http.put<any>("/api/TipoPunitorio/Update",updateTipoPunitorioRequest);
  }

  getAll():Observable<TipoPunitorioDto[]>
  {
    return  this.http.get<TipoPunitorioDto[]>("/api/TipoPunitorio/GetAll");
  }

  getById(id:number):Observable<TipoPunitorioDto>
  {
    return  this.http.get<TipoPunitorioDto>("/api/TipoPunitorio/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/TipoPunitorio/Delete?id=" + id);
    else
      return of(null)
  }
}
